import { render, staticRenderFns } from "./organization_info.vue?vue&type=template&id=68733b6a&scoped=true&"
import script from "./organization_info.vue?vue&type=script&lang=js&"
export * from "./organization_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68733b6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68733b6a')) {
      api.createRecord('68733b6a', component.options)
    } else {
      api.reload('68733b6a', component.options)
    }
    module.hot.accept("./organization_info.vue?vue&type=template&id=68733b6a&scoped=true&", function () {
      api.rerender('68733b6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/organizations/tabs/organization_info.vue"
export default component.exports